
<template >
  <div class="bg-beige" :class="{ withMobileHero: mobileHero }" style="min-height:100vh;">
    <RegMobileHero v-if="mobileHero" />
    <div class="flexi pv50 regLayoutBody">
      <tbl_nm class="regLayoutHeader">
        <cl class="vm w50 l">
          <router-link :to="{ name: 'homepage' }">
          <img src="@/assets/imgs/web/logo.svg" alt="" loading="lazy" class="wa header-logo" data-aos="fade-right" data-aos-delay="100">
          </router-link>
        </cl>
        <cl class="vm w50 r">
          <img src="@/assets/imgs/reg/orgBy.png" alt="" loading="lazy" class="wa header-logo" data-aos="fade-left" data-aos-delay="100">
        </cl>
      </tbl_nm>
      <div class="mt60 regLayoutContent">
        <router-view></router-view>
      </div>
    </div>
    <RegMobileFooter v-if="$route.meta.mobileFooter" />
  </div>
  <!-- <Footer /> -->
  <div class="pf ov bgb10 " v-if="$store.state.loader==1" style="z-index: 9999999;">
     <div class="cc c">
      <span class="mainloader"></span>
     </div>
  </div>
  <!-- <div class="pf ov bgb10 " v-if="$store.state.loader==1" style="z-index: 9999999;">
    <img src="@/assets/imgs/loader.gif" alt="" class="cc" style="width: 100px;">
  </div> -->
  <div class="pf ov bgb10 " v-if="$store.state.showPopUp" style="z-index: 9999999;">
    <div class="cc w90 popUp oya" >
      <div v-if="$store.state.apiStatus==true">
        <img src="@/assets/imgs/reg/check.svg" alt="" class="w100" style="width: 100px;">
        <p class="c-brown-dark fs20">{{ $store.state.popUpMessage }}</p>
        <div class="c mt15"><div class="g_nm w100 goBackButton mt30" @click="close(1)" style="max-width: 200px;">Ok</div></div>
      </div>
      <div v-if="$store.state.apiStatus==false">
        <p class="c-brown-dark fs20">{{ $store.state.popUpMessage }}</p>
        <div class="c mt15"><div class="g_nm w100 goBackButton mt30" @click="close(0)" style="max-width: 200px;">Ok</div></div>
      </div>
    </div>
  </div>
</template>

<script>
import Footer from '@/components/Common/Footer.vue';
import RegMobileHero from '@/components/Registration/RegMobileHero.vue';
import RegMobileFooter from '@/components/Registration/RegMobileFooter.vue';
// import 'maz-ui/css/main.css'
import "maz-ui/css/main.css";
import Select2 from "vue3-select2-component";
import '@/assets/css/regStyle.css'

  export default {
    name: "RegLayout",
    components: {
      Select2,Footer,RegMobileHero,RegMobileFooter
    },
    data(){
      return{
        errorTimeouts: {}
      }
    },
    computed: {
      // Routes with meta `mobileHero` use the hero design on mobile
      mobileHero(){
        return this.$route.meta.mobileHero === true;
      }
    },
    mounted() {
      $('body').removeClass('rtl');
      this.$i18n.locale='en';
      $('html').attr('lang','en');

    },
    methods: {
      enarSpaceNoChar(e, errorClass) {
        // allo en ar space  number en number ar - / , enter space but no other  char
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        // Allow English letters, Arabic letters, spaces, numbers, and - / ,
        const regex = /^[a-zA-Z\u0600-\u06FF0-9\s\-\/,]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English and Arabic letters, numbers, spaces, and - / , are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      arWithSpace(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[\u0600-\u06FF\s]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only Arabic letters and spaces are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      enWithSpace(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[a-zA-Z\s]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English letters and spaces are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      enWithoutSpace(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[a-zA-Z]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English letters are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      checkNoSpical(e) {
        // Prevent special characters
        const regex = /[^a-zA-Z0-9\s]/;
        if (regex.test(e.key)) {
          e.preventDefault();
        }
      },
      checkNoSpicalNoSpace(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /[^a-zA-Z0-9]/;
        if (regex.test(e.key)) {
          errorDiv.text('Only English letters and numbers are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      onlyNumberslessThen_eight(e, errorClass){
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[2-8]$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only numbers between 2 and 8 are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      handlePaste(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        errorDiv.text('Pasting is not allowed.');
        errorInput.addClass('error');
        // errorDiv.slideDown();
        if (this.errorTimeouts[errorClass]) {
          clearTimeout(this.errorTimeouts[errorClass]);
        }
        this.errorTimeouts[errorClass] = setTimeout(() => {
          // errorDiv.slideUp();
          errorInput.removeClass('error');
          this.errorTimeouts[errorClass] = null;
        }, 3000);
        // e.preventDefault();
      },
      preventCopy(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        errorDiv.text('Copy/Cut is not allowed.');
        errorInput.addClass('error');
        // errorDiv.slideDown();
        if (this.errorTimeouts[errorClass]) {
          clearTimeout(this.errorTimeouts[errorClass]);
        }
        this.errorTimeouts[errorClass] = setTimeout(() => {
          // errorDiv.slideUp();
          errorInput.removeClass('error');
          this.errorTimeouts[errorClass] = null;
        }, 3000);
        // e.preventDefault();
      },
      allowedEmailChar(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[a-zA-Z0-9@._+\-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only english letters, numbers and @ . _ - are allowed in email.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      onlyNumbers(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        const regex = /^[0-9]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only numbers are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      enarSpaceDash(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        // Allow English letters, Arabic letters, spaces, and -
        const regex = /^[a-zA-Z\u0600-\u06FF\s-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English and Arabic letters, spaces and - are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      enSpaceNumChar(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        // Allow English letters, numbers, spaces, #, and -
        const regex = /^[a-zA-Z0-9\s-]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Only English letters, numbers, spaces and - are allowed.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      link(e, errorClass) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        // Allow URL characters
        const regex = /^[a-zA-Z0-9-._~:/?#[\]@!$&'()*+,;=%]*$/;
        if (!regex.test(e.key)) {
          errorDiv.text('Invalid character for URL.');
          errorInput.addClass('error');
          errorDiv.slideDown();
          if (this.errorTimeouts[errorClass]) {
            clearTimeout(this.errorTimeouts[errorClass]);
          }
          this.errorTimeouts[errorClass] = setTimeout(() => {
            errorDiv.slideUp();
            errorInput.removeClass('error');
            this.errorTimeouts[errorClass] = null;
          }, 3000);
          e.preventDefault();
        }
      },
      validatedata(formname, errorClass, text) {
        var errorInput = $('.' + errorClass + 'input');
        var errorDiv = $('.' + errorClass + 'error');
        if (formname == "" || formname == null ) {
          $(errorDiv).html(text);
          $(errorDiv).slideDown();
          $(errorInput).addClass('error');
          return 0;
        } else {
          $(errorInput).removeClass('error');
          $(errorDiv).slideUp();
          return 1;
        }
      },
      close(stauts){
        if(stauts==0){
          this.$store.state.showPopUp=false;
        }
        else{
          this.$store.state.showPopUp=false;
          this.$router.push({ name: 'homepage' });
        }
      }
    },    
    provide() {
      return {
        checkNoSpical: this.checkNoSpical,
        handlePaste: this.handlePaste,
        preventCopy: this.preventCopy,
        enWithSpace: this.enWithSpace,
        arWithSpace: this.arWithSpace,
        allowedEmailChar: this.allowedEmailChar,
        onlyNumbers: this.onlyNumbers,
        validatedata: this.validatedata,
        enSpaceNumChar: this.enSpaceNumChar,
        enWithoutSpace: this.enWithoutSpace,
        checkNoSpicalNoSpace: this.checkNoSpicalNoSpace,
        onlyNumberslessThen_eight: this.onlyNumberslessThen_eight,
        enarSpaceDash: this.enarSpaceDash,
        link: this.link,
        enarSpaceNoChar: this.enarSpaceNoChar,

      };
    }
  }
</script>

<style scoped>
@media all and (max-width:768px) {
  .withMobileHero{
    display: flex;
    flex-direction: column;
    background-color: var(--offwhite);
  }
  .withMobileHero > .regLayoutBody{
    flex: 1 0 auto; /* keeps the footer at the bottom of short pages */
    /* overrides the mobile `.flexi { padding: 0 15px !important }` in commonStyle.css */
    padding: 16px !important;
  }
  .withMobileHero .regLayoutHeader{
    display: none;
  }
  .withMobileHero .regLayoutContent{
    margin-top: 0;
  }
}
</style>
